"use strict";

export const catnav = function() {
    const list_items = document.querySelectorAll('.js-meter-wrapper');

    function deleteElements( selector_string ) {
        const elements = document.querySelectorAll(selector_string);
        Array.prototype.forEach.call( elements, function( node ) {
            node.parentNode.removeChild( node );
        });
    }

    function resetWidths() {
        deleteElements('.js-meter');

        Array.prototype.forEach.call(list_items, (el) => {
            const meter = document.createElement("div");
            meter.classList.add('js-meter');
            meter.style.borderLeftWidth = (el.getAttribute('data-percent') / 100 * el.clientWidth) + 'px';
            el.appendChild(meter);
        });
    }

    const init = function() {
        resetWidths();

        window.addEventListener('resize', () => {
            resetWidths();
        });
    };

    return { init };

}();